var React = require('react');

function PauseIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.pause-icon-svg{fill:#666766;}\n"),React.createElement("path",{"className":"pause-icon-svg","d":"M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0z M10,18c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8\n\tS14.4,18,10,18z","key":1}),React.createElement("path",{"id":"Rounded_Rectangle_12_copy_2","className":"pause-icon-svg","d":"M8,7c0.6,0,1,0.4,1,1v4c0,0.6-0.4,1-1,1s-1-0.4-1-1V8C7,7.4,7.4,7,8,7z M12,7\n\tc0.6,0,1,0.4,1,1v4c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1V8C11,7.4,11.4,7,12,7z","key":2})]);
}

PauseIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 20 20","style":{"enableBackground":"new 0 0 20 20"},"xmlSpace":"preserve","width":"20","height":"20"};

module.exports = PauseIcon;

PauseIcon.default = PauseIcon;
